/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["file-icon{display:inline-block;flex-shrink:0;width:24px;height:24px}file-icon>.mat-icon{width:100%;height:100%}"];
export { styles as styles };
